<template>
  <sellpact-check
    :pagetitle="`销售合同审批详情`"
    :sna-id="snaId"
  ></sellpact-check>
</template>

<script>
import sellpactCheck from '@/views/workbench/workCheckManage/sellpactCheck/sellpactCheck'
import checkMixin from '@/mixin/checkMixin'
import routerMixin from '@/mixin/routerMixin'
export default {
  name: 'sellpactCheckDetail',
  components: {
    sellpactCheck
  },
  mixins: [checkMixin, routerMixin]
}
</script>

<style scoped></style>
